export default __webpack_public_path__ + "static/media/huibuh-lp-grafik-03.bcb488cb.png";